import { render, staticRenderFns } from "./generator.area-trigger.description.vue?vue&type=template&id=015cc031&"
import script from "./generator.area-trigger.description.vue?vue&type=script&lang=ts&"
export * from "./generator.area-trigger.description.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports